import React, {
  Suspense,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import { postEmployeeFollow } from "../Services/DashboardServices";
import { LoaderContext } from "../../../../Services/Loader_Provider_Service/LoadingContext";
import { getTrans as T } from "../../../../Shared/Language";
import { TostMsg } from "../../../../App";
import { getEmployeeList } from "../../EmployeeList/Service/employeeService";
import { Dialog } from "primereact/dialog";
import { LazyImage } from "../../../../Services/Decorator_Lazy_Loading/ImageVideoLazyLoding";
import LoginLoader from "../../../../Shared/Sidebar/LoginLoader";
import Skeleton from "react-loading-skeleton";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import ERROR_LIST from "../../../../Services/Global-Services/Hadle_Errors";
const ComponentLoader = React.lazy(() =>
  import("../../../../Shared/Sidebar/ComponentLoader")
);
const defaultImage = "/images/placeholder_profile.png";

const FollowUpSuggestions = ({ EmpId }) => {
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  let CurrentEmpId = EmpId;
  const toster = useContext(TostMsg);
  const [Isloading, setIsloading] = useState(true);
  const [employee, setEmployee] = useState([]);

  async function PostEmployeeFollow(Id) {
    const updatedEmployeeFollowStatus = employee.map((emp) => {
      if (emp.EmpId === Id) {
        const isCurrentlyFollowed = emp.IsFollowed === 1;
        const currentCount = Number(emp.FollowersCount) || 0;
        const updatedFollowersCount = isCurrentlyFollowed
          ? currentCount - 1
          : currentCount + 1;
        return {
          ...emp,
          IsFollowed: isCurrentlyFollowed ? 0 : 1,
          FollowersCount: updatedFollowersCount,
        };
      }
      return emp;
    });
    setEmployee(updatedEmployeeFollowStatus);
    try {
      let params = {
        FollowerId: userDetails?.EmpId,
        EmpId: Id,
      };
      await postEmployeeFollow(params);
    } catch (error) {
      const revertedData = employee.map((emp) => {
        if (emp.EmpId === Id) return emp;
        return emp;
      });
      setEmployee(revertedData);
      setIsloading(false);
      toster.current.error(ERROR_LIST.DefaultError);
    }
  }

  useEffect(() => {
    fetchEmployeeData();
  }, [CurrentEmpId]);

  //Get Employee List from EmployeeList service
  async function fetchEmployeeData() {
    setIsloading(true);
    var params = {
      OrganisationId: userDetails?.OrgId,
      LoggedInEmployeeId: userDetails?.EmpId,
      IsDirectReportOrHierarchy: 0,
      SearchText: "",
      FollowersOnly: 0,
      FollowingsOnly: 0,
      IsExEmployeesAlso: 0,
      pageNumber: 1,
      pageSize: 1000000,
      EmployeeId: 0,
      IsSuggestedOnly: 0,
    };
    try {
      let employeesList = await getEmployeeList(params);
      let FollowListData = employeesList.Data.filter(
        (emp) => emp.EmpId !== userDetails.EmpId
      );
      FollowListData = FollowListData.filter((emp) => emp.IsFollowed === 0);
      FollowListData.sort(
        (a, b) => (b.EmpId === CurrentEmpId) - (a.EmpId === CurrentEmpId)
      );
      setEmployee(FollowListData);
      setIsloading(false);
    } catch (error) {
      toster.current.error(ERROR_LIST.DefaultError);
      setIsloading(false);
    }
  }

  const handleImageError = useCallback((event) => {
    event.target.src = defaultImage; // Set the fallback image on error
  }, []);

  return (
    <>
      {" "}
      {Isloading ? (
        <Skeleton height={270} width="100%" />
      ) : (
        <div className="col-xl-12 dashboard-followup">
          <div className="card">
            <div className="card-body">
              <div className="custom-tab-1">
                <strong className="upcome">{T("Follow Up Suggestions")}</strong>
                <Link className="more-icon" to="/Follow/Suggestion">
                  <i className="fa fa-angle-right"></i>
                </Link>
                <div
                  className="tab-pane container fade mt-0 p-0 pt-2 active show"
                  id="menu1"
                >
                  {employee // Filter only followed users
                    .slice(0, 3) // Only show the first 3 followed users
                    .map((emp) => (
                      <div
                        key={emp.Id}
                        className="media mb-2 align-items-start g-5 event-list"
                      >
                        <div className="h-avatar is-medium">
                          <Link to={`/Profile/${emp?.GUID}`}>
                            <img
                              className="avatar"
                              src={emp?.ProfileImage || defaultImage}
                              onError={handleImageError}
                              data-demo-src="/images/avatar/1.jpg"
                              alt={emp?.FullName}
                              data-user-popover="25"
                              data-target="webuiPopover6"
                            />
                          </Link>
                        </div>
                        <div className="media-body">
                          <Link to={`/Profile/${emp?.GUID}`}>
                            <p className="title">
                              <a className="text-black">{emp?.FullName}</a>
                            </p>
                            <p className="designation flex items-center gap-2 text-gray-700 font-medium mb-0">
                              <span className="fs-12">
                                {emp?.CurrentDesignation}
                              </span>
                              <span className="text-gray-400"> | </span>
                              <span className="text-gray-500 fs-12">
                                {emp?.CurrentDepartment}
                              </span>
                            </p>

                            {/* <p className="desgination mb-0">
                              {emp?.CurrentDesignation} Dep:{emp?.CurrentDepartment}
                            </p> */}
                            <div className="">
                              <span className="fs-12 text-primary me-2">
                                Follow : {emp?.FollowersCount}
                              </span>
                              | &nbsp;
                              <span className="fs-12 text-info">
                                Following : {emp?.FollowingCount}
                              </span>
                            </div>
                          </Link>
                        </div>
                        {userDetails?.EmpId !== emp?.EmpId && (
                          <>
                            {emp.IsFollowed === 0 ? (
                              <div
                                onClick={() => PostEmployeeFollow(emp.Id)}
                                className="follow-unfollow-member"
                                style={{
                                  cursor: "pointer",
                                  marginLeft: "auto",
                                }}
                                title="Follow"
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="16"
                                  height="16"
                                  fill="currentColor"
                                  className="bi bi-hand-thumbs-up-fill"
                                  viewBox="0 0 16 16"
                                >
                                  <path d="M6.956 1.745C7.021.81 7.908.087 8.864.325l.261.066c.463.116.874.456 1.012.965.22.816.533 2.511.062 4.51a10 10 0 0 1 .443-.051c.713-.065 1.669-.072 2.516.21.518.173.994.681 1.2 1.273.184.532.16 1.162-.234 1.733q.086.18.138.363c.077.27.113.567.113.856s-.036.586-.113.856c-.039.135-.09.273-.16.404.169.387.107.819-.003 1.148a3.2 3.2 0 0 1-.488.901c.054.152.076.312.076.465 0 .305-.089.625-.253.912C13.1 15.522 12.437 16 11.5 16H8c-.605 0-1.07-.081-1.466-.218a4.8 4.8 0 0 1-.97-.484l-.048-.03c-.504-.307-.999-.609-2.068-.722C2.682 14.464 2 13.846 2 13V9c0-.85.685-1.432 1.357-1.615.849-.232 1.574-.787 2.132-1.41.56-.627.914-1.28 1.039-1.639.199-.575.356-1.539.428-2.59z" />
                                </svg>
                              </div>
                            ) : (
                              <>
                                <div
                                  onClick={() => PostEmployeeFollow(emp.Id)}
                                  className="follow-unfollow-member"
                                  style={{
                                    cursor: "pointer",
                                    marginLeft: "auto",
                                  }}
                                  title="UnFollow"
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    style={{
                                      color: "#ffffff",
                                      background: " #671cc9",
                                    }}
                                    fill="currentColor"
                                    className="bi bi-hand-thumbs-down-fill"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M6.956 14.534c.065.936.952 1.659 1.908 1.42l.261-.065a1.38 1.38 0 0 0 1.012-.965c.22-.816.533-2.512.062-4.51q.205.03.443.051c.713.065 1.669.071 2.516-.211.518-.173.994-.68 1.2-1.272a1.9 1.9 0 0 0-.234-1.734c.058-.118.103-.242.138-.362.077-.27.113-.568.113-.856 0-.29-.036-.586-.113-.857a2 2 0 0 0-.16-.403c.169-.387.107-.82-.003-1.149a3.2 3.2 0 0 0-.488-.9c.054-.153.076-.313.076-.465a1.86 1.86 0 0 0-.253-.912C13.1.757 12.437.28 11.5.28H8c-.605 0-1.07.08-1.466.217a4.8 4.8 0 0 0-.97.485l-.048.029c-.504.308-.999.61-2.068.723C2.682 1.815 2 2.434 2 3.279v4c0 .851.685 1.433 1.357 1.616.849.232 1.574.787 2.132 1.41.56.626.914 1.28 1.039 1.638.199.575.356 1.54.428 2.591" />
                                  </svg>
                                </div>
                              </>
                            )}
                          </>
                        )}
                      </div>
                    ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {/* <div className="modal fade" id="follow-ups">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title m-auto">
                {T("Follow Up Suggestions")}
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body">
              <div
                className="languages-wrapper904"
                style={{ height: "400px", overflow: "auto" }}
              >
                {employee.map((emp) => (
                  <div
                    className="languages-item position-relation"
                    key={emp.Id}
                  >
                    <div className="icon-wrap">
                      <LazyImage
                        src={emp?.ProfileImage || defaultImage}
                        onError={handleImageError}
                      />
                      <span
                        className="languages-donut"
                        style={{ display: "none" }}
                      >
                        100/100
                      </span>
                      <svg className="peity" height="50" width="50">
                        <path
                          d="M 25 0 A 25 25 0 1 1 24.99 0 L 24.99 3 A 22 22 0 1 0 25 3"
                          data-value="100"
                          fill="#27d9d7"
                        ></path>
                      </svg>
                    </div>
                    <div className="meta">
                      <span className="dark-inverted">{emp?.FullName}</span>
                      <span>{emp?.CurrentDesignation}</span>
                    </div>
                    {userDetails?.EmpId !== emp?.EmpId && (
                      <>
                        {emp.IsFollowed === 0 ? (
                          <div
                            onClick={() => PostEmployeeFollow(emp.Id)}
                            className="follow-unfollow-member"
                            style={{ cursor: "pointer", marginLeft: "auto" }}
                            title="Follow"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="currentColor"
                              className="bi bi-hand-thumbs-up-fill"
                              viewBox="0 0 16 16"
                            >
                              <path d="M6.956 1.745C7.021.81 7.908.087 8.864.325l.261.066c.463.116.874.456 1.012.965.22.816.533 2.511.062 4.51a10 10 0 0 1 .443-.051c.713-.065 1.669-.072 2.516.21.518.173.994.681 1.2 1.273.184.532.16 1.162-.234 1.733q.086.18.138.363c.077.27.113.567.113.856s-.036.586-.113.856c-.039.135-.09.273-.16.404.169.387.107.819-.003 1.148a3.2 3.2 0 0 1-.488.901c.054.152.076.312.076.465 0 .305-.089.625-.253.912C13.1 15.522 12.437 16 11.5 16H8c-.605 0-1.07-.081-1.466-.218a4.8 4.8 0 0 1-.97-.484l-.048-.03c-.504-.307-.999-.609-2.068-.722C2.682 14.464 2 13.846 2 13V9c0-.85.685-1.432 1.357-1.615.849-.232 1.574-.787 2.132-1.41.56-.627.914-1.28 1.039-1.639.199-.575.356-1.539.428-2.59z" />
                            </svg>
                          </div>
                        ) : (
                          <>
                            <div
                              onClick={() => PostEmployeeFollow(emp.Id)}
                              className="follow-unfollow-member"
                              style={{ cursor: "pointer", marginLeft: "auto" }}
                              title="UnFollow"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                style={{
                                  color: "#ffffff",
                                  background: " #671cc9",
                                }}
                                fill="currentColor"
                                className="bi bi-hand-thumbs-down-fill"
                                viewBox="0 0 16 16"
                              >
                                <path d="M6.956 14.534c.065.936.952 1.659 1.908 1.42l.261-.065a1.38 1.38 0 0 0 1.012-.965c.22-.816.533-2.512.062-4.51q.205.03.443.051c.713.065 1.669.071 2.516-.211.518-.173.994-.68 1.2-1.272a1.9 1.9 0 0 0-.234-1.734c.058-.118.103-.242.138-.362.077-.27.113-.568.113-.856 0-.29-.036-.586-.113-.857a2 2 0 0 0-.16-.403c.169-.387.107-.82-.003-1.149a3.2 3.2 0 0 0-.488-.9c.054-.153.076-.313.076-.465a1.86 1.86 0 0 0-.253-.912C13.1.757 12.437.28 11.5.28H8c-.605 0-1.07.08-1.466.217a4.8 4.8 0 0 0-.97.485l-.048.029c-.504.308-.999.61-2.068.723C2.682 1.815 2 2.434 2 3.279v4c0 .851.685 1.433 1.357 1.616.849.232 1.574.787 2.132 1.41.56.626.914 1.28 1.039 1.638.199.575.356 1.54.428 2.591" />
                              </svg>
                            </div>
                          </>
                        )}
                      </>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div> */}
    </>
  );
};

export default FollowUpSuggestions;

export const FollowersAndFollowing = (args, { userId }) => {
  const type = args.ChangeType;
  const [visibleFollowers, setVisibleFollowers] = useState(false);
  const [visibleFollowings, setVisibleFollowings] = useState(false);
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const toster = useContext(TostMsg);
  const [Isloading, setIsloading] = useState(false);
  const [followingCount, setFollowingCount] = useState([]);
  const [followersListData, setFollowersListData] = useState([]);
  const [followingListDetails, setFollowingListDetails] = useState([]);
  const [likeLoader, setLikeLoader] = useState(false);

  //Get Folowers list data of employee.
  async function fetchEmployeeFolowersData() {
    setIsloading(true);
    var params = {
      OrganisationId: userDetails?.OrgId,
      LoggedInEmployeeId: userDetails?.EmpId,
      IsDirectReportOrHierarchy: 0,
      SearchText: "",
      FollowersOnly: 1,
      FollowingsOnly: 0,
      IsExEmployeesAlso: 0,
      pageNumber: 1,
      pageSize: 1000000,
      EmployeeId: args?.userId,
      IsSuggestedOnly: 0,
    };
    try {
      let employeesFolowersList = await getEmployeeList(params);
      // let employeesFolowersList = await data.json();
      let FollowersDataList = employeesFolowersList?.Data.filter(
        (Followers) => Followers.Id != Number(args?.userId)
      );
      setFollowersListData(FollowersDataList);
      setIsloading(false);
    } catch (error) {
      toster.current.error(ERROR_LIST.DefaultError);
      setIsloading(false);
    }
  }
  //Get Employee List from EmployeeList service
  async function fetchEmployeeData() {
    //setIsloading(true);
    var params = {
      OrganisationId: userDetails?.OrgId,
      LoggedInEmployeeId: userDetails?.EmpId,
      IsDirectReportOrHierarchy: 0,
      SearchText: "",
      FollowersOnly: 0,
      FollowingsOnly: 1,
      IsExEmployeesAlso: 0,
      pageNumber: 1,
      pageSize: 1000000,
      EmployeeId: args?.userId,
      IsSuggestedOnly: 0,
    };
    try {
      let employeesList = await getEmployeeList(params);
      let followingListData = employeesList.Data.filter(
        (Follow) => Follow.IsFollowed === 1
      );

      setFollowingCount(followingListData);
      let falowersListData = employeesList.Data.filter(
        (Folowers) => Folowers.Id != Number(args?.userId)
      );

      setFollowingListDetails(falowersListData);
      setIsloading(false);
    } catch (error) {
      toster.current.error(ERROR_LIST.DefaultError);
      setIsloading(false);
    }
  }

  useEffect(() => {
    if (type === 1) {
      setVisibleFollowers(true);
      fetchEmployeeFolowersData();
    } else if (type === 2) {
      setVisibleFollowings(true);
      fetchEmployeeData();
    }
  }, [type]);

  async function PostEmployeeFollow(Id) {
    let params = {
      FollowerId: userDetails?.EmpId,
      EmpId: Id,
    };
    try {
      setLikeLoader(true);
      const data = await postEmployeeFollow(params);
      fetchEmployeeData();
      setLikeLoader(false);
      toster.current.success("Emp Following.");
    } catch (error) {
      setLikeLoader(false);
      toster.current.error(ERROR_LIST.DefaultError);
    }
  }
  const handleImageError = useCallback((event) => {
    event.target.src = defaultImage; // Set the fallback image on error
  }, []);

  return (
    <>
      <Dialog
        visible={visibleFollowers}
        style={{ width: "50vw" }}
        onHide={() => {
          if (!visibleFollowers) return;
          setVisibleFollowers(false);
        }}
      >
        <div className="modal-header">
          <h5 className="modal-title m-auto">
            {followersListData.length} Followers
          </h5>
        </div>
        <div className="modal-body">
          <div
            className="languages-wrapper904"
            style={{ height: "400px", overflow: "auto" }}
          >
            {followersListData.map((followers, index) => {
              return (
                <div className="languages-item" key={index}>
                  <div className="list-container">
                    <div className="icon-wrap">
                      <LazyImage
                        src={followers?.ProfileImage || defaultImage}
                        onError={handleImageError}
                      />
                      <span
                        className="languages-donut"
                        style={{ display: "none" }}
                      >
                        100/100
                      </span>
                      <svg className="peity" height="50" width="50">
                        <path
                          d="M 25 0 A 25 25 0 1 1 24.99 0 L 24.99 3 A 22 22 0 1 0 25 3"
                          data-value="100"
                          fill="#27d9d7"
                        ></path>
                      </svg>
                    </div>
                    <div className="meta">
                      <span className="dark-inverted">
                        {followers?.FullName}
                      </span>
                      <span>{followers?.CurrentDesignation}</span>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </Dialog>
      <Dialog
        visible={visibleFollowings}
        style={{ width: "50vw" }}
        onHide={() => {
          if (!visibleFollowings) return;
          setVisibleFollowings(false);
        }}
      >
        <div className="modal-header">
          <h5 className="modal-title m-auto">
            {followingCount.length} Followings
          </h5>
        </div>
        <div className="modal-body">
          <div
            className="languages-wrapper904"
            style={{ height: "400px", overflow: "auto" }}
          >
            {followingListDetails.map((following, index) => {
              return (
                <>
                  {" "}
                  {following.IsFollowed === 1 ? (
                    <>
                      {" "}
                      <div
                        className="languages-item position-relation"
                        key={following?.Id}
                      >
                        <div className="icon-wrap">
                          <LazyImage
                            src={following?.ProfileImage || defaultImage}
                            onError={handleImageError}
                          />
                          <span
                            className="languages-donut"
                            style={{ display: "none" }}
                          >
                            100/100
                          </span>
                          <svg className="peity" height="50" width="50">
                            <path
                              d="M 25 0 A 25 25 0 1 1 24.99 0 L 24.99 3 A 22 22 0 1 0 25 3"
                              data-value="100"
                              fill="#27d9d7"
                            ></path>
                          </svg>
                        </div>
                        <div className="meta">
                          <span className="dark-inverted">
                            {following?.FullName}
                          </span>
                          <span>{following?.CurrentDesignation}</span>
                        </div>
                        <div
                          onClick={() => PostEmployeeFollow(following.Id)}
                          className="follow-unfollow-member"
                          style={{ cursor: "pointer", marginLeft: "auto" }}
                          title="UnFollow"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            style={{
                              color: "#ffffff",
                              background: " #671cc9",
                            }}
                            fill="currentColor"
                            className="bi bi-hand-thumbs-down-fill"
                            viewBox="0 0 16 16"
                          >
                            <path d="M6.956 14.534c.065.936.952 1.659 1.908 1.42l.261-.065a1.38 1.38 0 0 0 1.012-.965c.22-.816.533-2.512.062-4.51q.205.03.443.051c.713.065 1.669.071 2.516-.211.518-.173.994-.68 1.2-1.272a1.9 1.9 0 0 0-.234-1.734c.058-.118.103-.242.138-.362.077-.27.113-.568.113-.856 0-.29-.036-.586-.113-.857a2 2 0 0 0-.16-.403c.169-.387.107-.82-.003-1.149a3.2 3.2 0 0 0-.488-.9c.054-.153.076-.313.076-.465a1.86 1.86 0 0 0-.253-.912C13.1.757 12.437.28 11.5.28H8c-.605 0-1.07.08-1.466.217a4.8 4.8 0 0 0-.97.485l-.048.029c-.504.308-.999.61-2.068.723C2.682 1.815 2 2.434 2 3.279v4c0 .851.685 1.433 1.357 1.616.849.232 1.574.787 2.132 1.41.56.626.914 1.28 1.039 1.638.199.575.356 1.54.428 2.591" />
                          </svg>
                        </div>
                      </div>
                    </>
                  ) : (
                    ""
                  )}
                </>
              );
            })}
          </div>
        </div>
      </Dialog>
    </>
  );
};
